import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';

import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core.component';
import { FooterComponent } from './footer/footer.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PaymentFailureComponent } from './payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentCancelComponent } from './payment/payment-cancel.component';
import { PaymentComponent } from './payment/payment.component';
import { SupportComponent } from './support/support.component';
import { TermsComponent } from './terms/terms.component';
import { TierPriceComponent } from './tier-price/tier-price.component';
import { TierComponent } from './tier/tier.component';
import { ToastComponent } from './toast/toast.component';
import { ToastService } from './toast/toast.service';

@NgModule({
    imports: [
        // angular
        BrowserModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,

        // vendor
        Angulartics2Module.forRoot(),
        NgbModule,

        // app
        CoreRoutingModule,
    ],
    declarations: [
        CoreComponent,
        FooterComponent,
        NotFoundComponent,
        PaymentComponent,
        PaymentCancelComponent,
        PaymentFailureComponent,
        PaymentSuccessComponent,
        SupportComponent,
        TermsComponent,
        TierComponent,
        TierPriceComponent,
        ToastComponent,
    ],
    providers: [ToastService],
    entryComponents: [PaymentCancelComponent],
})
export class CoreModule {
    constructor(
        @Optional()
        @SkipSelf()
        parentModule: CoreModule
    ) {
        if (parentModule) {
            throw new Error(`CoreModule has already been loaded. Import Core modules in the AppModule only.`);
        }
    }
}
